<template>
  <v-container fluid>
    <StandarPageWithList
      title="Positions Organization"
      :hideActiveNo="true"
      :hideTopSection="true"
    >
      <template #action>
        <span></span>
      </template>
      <template #empty-content>
        <span></span>
      </template>
      <div class="ex-rolepage mb-8 mt-4" data-testid="ex-rolepage">
        <div class="mx-4 mb-4 d-flex justify-space-between">
          <ExBreadcrumbs
            class="custom-bread"
            :breadcrumbsList="computedBreadItems"
          />
        </div>
        <div class="header d-flex justify-space-between mb-2 mx-4">
          <div class="d-flex align-start" style="max-width: calc(100% - 160px)">
            <Icon class="mr-3 custom-org-icon" name="org_icon_role" />
            <div style="width: 100%">
              <div class="custom-status">
                <StatusBadge
                  :status="`${currentRole?.status || 'draft'}`"
                  :archived="currentRole?.archived"
                  class="mr-3"
                />
              </div>
              <div class="custom-org">
                <OrgObjectCard
                  :code="getOrgCodeName(currentRole)"
                  :name="`${currentRole?.name || ''}`"
                  :showIcon="false"
                  :removeUnderlineToName="true"
                />
              </div>
            </div>
          </div>
          <div class="proficiency" :class="{ 'v-hidden': true }">
            <ExProficiencyWeight :proficiencyWeight="100" :sliderIcon="true" />
          </div>
          <div class="org-menu-role chatter-with-menu-role">
            <div
              @click="openChatter(currentRole)"
              class="hide-left-border center-vertical chatter-type-icon"
            >
              <v-img
                class="chatter-icon"
                :src="require('@components/assets/ChatterIcon.svg')"
              />
            </div>
            <DropDownMenu
              :is-open="false"
              :dropdown-items="getReadinessCatalogsRoleItem(currentRole)"
              @onClick="
                handleReadinessOperations({
                  item: $event,
                  data: currentRole,
                })
              "
              :translateXOffset="12"
              :translateYOffset="16"
            >
              <template #activator>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="#344054"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
                    stroke="#344054"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
                    stroke="#344054"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </template>
            </DropDownMenu>
          </div>
        </div>
        <div class="menu">
          <RoleMenu
            :key="renderIndex"
            :items="menuItems"
            :value="selectedTab"
            class="ex-menu-div"
            data-test="responsibility-menu"
            @onChange="handleTabChange"
          />
        </div>
        <div class="content">
          <v-tabs-items v-model="selectedTab" class="custom-tabs">
            <v-tab-item
              :transition="false"
              v-for="(item, index) in menuItems"
              :key="index"
            >
              <v-card v-if="selectedTab == 2" elevation="0">
                <AttachedResponsibilitiesToARole
                  :table-data="filteredResponsibilities"
                  :pagination="paginationRolePageModel"
                  @onButtonAction="openAttachRes()"
                  @onSearchMode="$emit('onSearchMode', $event)"
                  @appliedFilter="handleAppliedFilters($event)"
                  class="role-to-res"
                  @onRowOperation="handleReadinessOperations($event)"
                  @detach="detachOrgObject($event)"
                  :loader="detachLoader"
                  @onAIAction="handleAIAction()"
                  @onAddAI="handleAIAction(true)"
                  @onAddIQ="handleAddIQAction()"
                  @openChatterDrawer="handleOpenChatterDrawer($event)"
                  @requestMoreCheckpointsChatter="handleLoadMoreChatterData()"
                  :chatterData="chatterData"
                  :totalChatterData="totalChatterData"
                  @sequenceReorder="reOrderData($event)"
                  @onRequest="handlePagination($event)"
                  @appliedFilterFromAPI="appliedFilterFromAPI($event)"
                  @searchTextData="searchTextData($event)"
                />
              </v-card>
              <v-card :elevation="0" v-if="selectedTab == 3">
                <ActivityStream
                  class="mx-3 mb-5"
                  :data-stream="roleChatterData"
                  :show-load-more-button="
                    totalRoleChatterData > roleChatterData.length
                  "
                  @onLoadMore="getChatterData(currentRole)"
                  :dynamicOffset="260"
                />
              </v-card>
              <v-card v-else></v-card>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
    </StandarPageWithList>
    <div>
      <GeneratingWithAIDialog
        :show="aiLoadingState.show"
        @update:show="aiLoadingState.show = $event"
        :text="aiLoadingState.text"
      />
      <AIDataDialog
        :show="aiDialog"
        @update:show="!$event ? resetAIData() : (aiDialog = $event)"
        :ai-data="aiData.visible"
        :roleName="currentRole?.name"
        @saveAIData="onSaveAIData"
        :actionButton="{
          show: aiData.stored.length - aiData.visible.length > 0,
          label: 'Show More...',
        }"
        @actionButtonClick="showThreeMoreAIData"
        :key="aiDialogKey"
      />
    </div>
    <AttachedResponsibility
      v-model="attachedResDialog"
      @onSave="attachedRes"
      :items="items"
      @item-selected="handleItemSelected"
      @add-item-selected="addHandleItemSelected"
      :parent-name="currentRole?.name || ''"
      :openDefault="openDefault"
      @input="closeDialog"
      :type="
        showAttachResponsibilitiesPicker
          ? 'attach_responsibility_role_new_picker'
          : 'attach_responsibility_role'
      "
      @load-more="loadMoreResponsibilities"
      @search="searchResponsibilities"
      :hasMoreData="hasMoreData"
      :isLoadingMore="isLoadingMore"
      :isAssigning="isAssigningObject"
    />
    <ActivateResponsibilityConfirmationModal
      :dialog="showActivateResponsibility"
      @close="showActivateResponsibility = false"
      @skip="skipActivateResponsibilities"
      @activate="activateAttachResponsibilities"
      :role="currentRole?.name"
      :draftResponsibilityCount="roleHasDraftResponsibility"
      :skipButtonLoader="skipButtonLoader"
      :activateButtonLoader="activateButtonLoader"
    />
    <ActivateRole
      v-if="currentRole"
      v-model="activateRoleDialog"
      @onSave="activateOrgRole"
      :role="currentRole"
    />
    <RenameRole
      v-model="showRenameRoleDialog"
      @onSave="renameOrgRole"
      :role="currentRole?.name || ''"
    />
    <DeleteRole
      v-if="currentRole"
      v-model="deleteRoleDialog"
      @onDelete="deleteOrgRole($event)"
      :role="currentRole || ''"
    />
    <RetiredRole
      v-if="currentRole"
      v-model="retiredRoleDialog"
      @onSave="retiredOrgRole"
      :role="currentRole"
    />
    <DeActivateRole
      v-if="currentRole"
      v-model="deActivateRoleDialog"
      @onSave="deActivateOrgRole"
      :role="currentRole"
    />
    <ReActivateRole
      v-if="currentRole"
      v-model="reActivateRoleDialog"
      @onSave="reActivateOrgRole"
      :role="currentRole"
    />
    <RenameResponsibility
      v-model="showRenameResponsibilityDialog"
      :responsibility="currentResponsibility?.data?.name || ''"
      @onSave="renameResponsibility($event)"
    />
    <DeActivateResponsibility
      v-model="showDeActivateResponsiblityDialog"
      :responsibility="currentResponsibility?.data?.name || ''"
      @onSave="deActivateResponsibility"
    />
    <AttachedResponsibilityToRole
      v-model="showAttachRoleDialog"
      OrgObjectType="Responsibility to Role"
      @onSave="attachResponsibilityToRole"
      :type="
        showAttachResponsibilitiesPicker
          ? 'respToRole_new_picker'
          : 'respToRole'
      "
      :items="attachableRoles"
      @item-selected="handleItemSelected"
      @add-item-selected="addNewRole"
      :parent-name="currentResponsibility?.data?.name || ''"
      :hasMoreData="hasMoreData"
      :isLoadingMore="isLoadingMore"
      @load-more="loadMoreRoles"
      @search="searchRoles"
      :isAssigning="isAssigningObject"
    />
    <ReActivateResponsibility
      v-model="showReActivateResponsiblityDialog"
      :responsibility="currentResponsibility?.data?.name || ''"
      @onSave="handleReActivateResponsibility"
    />
    <RetireResponsibility
      v-model="showRetireResponsibilityDialog"
      :responsibility="currentResponsibility?.data?.name || ''"
      @onSave="handleRetireResponsibility"
    />
    <ActivateResponsibility
      v-model="showActivateResponsiblityDialog"
      :responsibility="currentResponsibility?.data?.name || ''"
      @onSave="handleActivateResponsibility"
    />
    <DeleteResponsibility
      v-model="deleteResponsibilityDialog"
      :responsibility="currentResponsibility?.data?.name || ''"
      @onDelete="deleteAttachResponsibility"
    />
    <ChatterDrawer
      ref="drawerContainer"
      :drawer="drawer"
      :iconName="'org_icon_role'"
      :type="'Role'"
      :typeValue="currentRole && currentRole.name"
      :listData="listData"
      @closeDrawer="closeDrawer($event)"
      :chatterList="roleChatterData"
      :totalCheckpointChatter="totalRoleChatterData"
      @requestMoreCheckpointsChatter="getChatterData(currentRole)"
    />
    <ArchivePopUp
      :action="archiveAction"
      :type="currentObj"
      :show="showArchihvedResponsiblityDialog"
      :curretObj="currentObj == 'role' ? currentRole : currentResponsibility"
      @onClose="showArchihvedResponsiblityDialog = false"
      @onArchive="onArchiveCatalogs"
    ></ArchivePopUp>
  </v-container>
</template>
<script>
import StatusBadge from "@components/organizations/statusBadge/OrgObjectStatusBadge.vue";
import Icon from "@components/icons/Icon.vue";
import ExProficiencyWeight from "@components/ProficiencyWeight/ExProficiencyWeight.vue";
import RoleMenu from "@components/RoleMenu/RoleMenu.vue";
import OrgObjectCard from "@components/common/OrgObjectCard.vue";
import AttachedResponsibilitiesToARole from "@components/AttachedResponsibilitiesToARole/AttachedResponsibilitiesToARole.vue";
import ExBreadcrumbs from "@components/breadcrumbs/ExBreadcrumbs.vue";
import StandarPageWithList from "@components/common/PageHeaderWithButton.vue";
import ActivityStream from "@components/Chatter/ActivityStream.vue";
import GeneratingWithAIDialog from "@components/AI/GeneratingWithAIDialog.vue";
import AIDataDialog from "@components/AI/AIDataDialog.vue";
import ActivateResponsibilityConfirmationModal from "@components/ActivateResponsibilityConfirmationModal/ActivateResponsibilityConfirmationModal.vue";
import { mapState } from "vuex";
import AttachedResponsibilityToRole from "@components/RolesCatalog/AttachedResponsibilityToRole.vue";
import {
  getRole,
  getChatterList,
  attachResponsibilityToRole,
  createResponsibility,
  updateRole,
  updateRetiredRole,
  deleteReadinessRole,
  deleteReadinessRoleWithResponsibilities,
  updateDeActiveRole,
  updateReActiveRole,
  // createResponsibilityCheckpoint,
  getPositionId,
  reOrderSequenceData,
  updateNameRole,
  deleteResponsibility,
  createBulkResponsiblities,
  attachResponsibilitiesToRoleBulk,
  // createBulkCheckpoints,
  askOpenai,
} from "@/api";
import { transformChatterData } from "@/utils/chatterUtils";
import AttachedResponsibility from "@components/RolesCatalog/AttachedRole.vue";
import dropdownMixin from "@components/DropDownMenu/dropdownMixin";
import roleMixin from "@components/views/mixins/roleMixin";
import DropDownMenu from "@components/DropDownMenu/DropDownMenu.vue";
import ActivateRole from "@components/RolesCatalog/ActivateRole.vue";
import RetiredRole from "@components/RolesCatalog/RetiredRole.vue";
import DeleteRole from "@components/RolesCatalog/DeleteRole.vue";
import RenameRole from "@components/RolesCatalog/RenameRole.vue";
import DeActivateRole from "@components/RolesCatalog/DeActivateRole.vue";
import ReActivateRole from "@components/RolesCatalog/ReActivateRole.vue";
import responsibilityMixin from "@components/views/mixins/responsibilityMixin";
import RenameResponsibility from "@components/RolesCatalog/RenameResponsibility.vue";
import ChatterDrawer from "@components/Drawer/ChatterDrawer.vue";
import ArchivePopUp from "@components/common/ArchivePopUp.vue";
import DeleteResponsibility from "@components/RolesCatalog/DeleteResponsibility.vue";
import { useIQOverlayStore } from "@/store/pinia/iqOverlay";
import { useIQChatStore } from "@components/IQOverlay/store/iqChatStore";
export default {
  name: "RolePageView",
  components: {
    AttachedResponsibilityToRole,
    StatusBadge,
    Icon,
    ExProficiencyWeight,
    RoleMenu,
    OrgObjectCard,
    AttachedResponsibilitiesToARole,
    ExBreadcrumbs,
    StandarPageWithList,
    ActivityStream,
    AttachedResponsibility,
    DropDownMenu,
    ActivateRole,
    DeleteRole,
    RenameRole,
    RetiredRole,
    DeActivateRole,
    ReActivateRole,
    RenameResponsibility,
    GeneratingWithAIDialog,
    AIDataDialog,
    ChatterDrawer,
    ArchivePopUp,
    ActivateResponsibilityConfirmationModal,
    DeleteResponsibility,
  },
  mixins: [dropdownMixin, roleMixin, responsibilityMixin],
  data() {
    return {
      drawer: false,
      totalCheckpointChatter: 0,
      currentResponsibility: null,
      renderIndex: 0,
      selectedTab: 2,
      menuItems: [
        { title: "Assignments", count: null },
        { title: "Description", count: null },
        { title: "Attachments", count: null },
        // { title: "Defaults", count: null },
        { title: "Chatter", count: null },
      ],
      currentRoleId: null,
      currentResponsibilityId: null,
      attachedResponsibilitiesIds: [],
      currentRole: null,
      chatterData: [],
      totalChatterData: 0,
      roleChatterData: [],
      totalRoleChatterData: 0,
      accountID: null,
      attachedResDialog: false,
      attachmentId: null,
      resItems: [],
      activateRoleDialog: false,
      retiredRoleDialog: false,
      deleteRoleDialog: false,
      showRenameRoleDialog: false,
      deActivateRoleDialog: false,
      reActivateRoleDialog: false,
      showRenameResponsibilityDialog: false,
      deleteResponsibilityDialog: false,
      showActivateResponsiblityDialog: false,
      showRetireResponsibilityDialog: false,
      showDeActivateResponsiblityDialog: false,
      showAttachRoleDialog: false,
      attachableRoles: [],
      showReActivateResponsiblityDialog: false,
      showArchihvedResponsiblityDialog: false,
      roleHasDraftResponsibility: false,
      showActivateResponsibility: false,
      aiDialog: false,
      appliedFiltersFromAPI: [],
      items: [],
      currentSearchTerm: "",
      aiDialogKey: 0,
      aiLoadingState: {
        show: false,
        text: "",
      },
      aiGenerating: false,
      aiRequestPromise: null,
      aiSuccessDataReady: false,
      aiData: {
        visible: [],
        stored: [],
        remaining: 0,
        key: 0,
      },
      loadingAIProcess: false,
      positionHeaderState: {
        status: "",
        icon: "org_icon_position",
        label: "Position",
        name: "",
      },
      listData: {},
      archiveAction: null,
      currentObj: null,
      loadedPages: {},
      activateButtonLoader: false,
      skipButtonLoader: false,
      openDefault: false,
      appliedFilters: [],
      hasMoreData: false,
      isLoadingMore: false,
      isAssigningObject: false,
      currentChatterItem: null,
    };
  },
  props: {
    dataStream: {
      type: Array,
      default: () => [
        {
          avatar: {
            picture: "",
            firstName: "Olivia",
            lastName: "Rhye",
          },
          IsExIQtiveBot: true,
          message: "Created",
          created_on: "1717459274000",
          IsHistory: true,
        },
        {
          avatar: {
            picture: "",
            firstName: "Olivia",
            lastName: "Rhye",
          },
          IsExIQtiveBot: true,
          message: "Created",
          created_on: "1717459202500",
          IsHistory: true,
        },
        {
          avatar: {
            picture: "https://cdn.vuetifyjs.com/images/john.jpg",
            firstName: "Olivia",
            lastName: "Rhye",
          },
          IsExIQtiveBot: true,
          message: "Created",
          created_on: "1717459206900",
          IsHistory: true,
        },
        {
          avatar: {
            picture: "https://cdn.vuetifyjs.com/images/john.jpg",
            firstName: "Olivia",
            lastName: "Rhye",
          },
          IsExIQtiveBot: false,
          message: "Created",
          created_on: "1717372803000",
          IsHistory: true,
        },
        {
          avatar: {
            picture: "",
            firstName: "Olivia",
            lastName: "Rhye",
          },
          IsExIQtiveBot: false,
          message: "Created",
          created_on: "1717372805000",
          IsHistory: true,
        },
        {
          avatar: {
            picture: "",
            firstName: "Olivia",
            lastName: "Rhye",
          },
          IsExIQtiveBot: false,
          message: "Created",
          created_on: "1717027200000",
          IsHistory: true,
        },
      ],
    },
  },
  computed: {
    ...mapState("readinessCatalogsStore", {
      storeResponsibilities: (state) => state.responsibilities,
    }),
    showAttachResponsibilitiesPicker() {
      return this.$store.getters["featureFlags/ideaMDP389"];
    },
    filteredResponsibilities() {
      const baseData = this.storeResponsibilities.map((el) => {
        const newEl = {};
        newEl.id = el.id;
        newEl.realId = el.id;
        newEl.parentId = -1;
        newEl.status = el.status;
        newEl.archived = el.archived;
        el.code = el.code + "";
        newEl.has_items = false;
        newEl.data = {
          type: "responsibility",
          ...el,
        };
        newEl.type = "responsibility";
        return newEl;
      });
      return baseData;

      // Apply filters using the roleMixin method
      // return this.applyFiltersToDataSource(baseData, "responsibility");
    },
    computedBreadItems() {
      let items = [
        {
          text: "Readiness Catalogs",
          disabled: false,
          href: "/readiness/catalogs",
        },
        {
          text: "Roles",
          disabled: false,
          href: "/readiness/catalogs/roles",
        },
        {
          text: "Role",
          disabled: true,
        },
      ];
      if (this.$route.name === "OrgPositionDetailObjId") {
        items[0] = {
          text: "Positions organization",
          disabled: false,
          href: "/organization/positions",
        };
        items[1] = {
          text: `${this.positionHeaderState?.name}`,
          icon: `${this.positionHeaderState?.icon}`,
          disabled: false,
          href: `/organization/positions/position/${this.$route.params.pId}`,
        };
        items[2] = {
          text: "Role",
          disabled: true,
        };
      }
      if (this.$route.name === "OrgPositionRolesResponse") {
        items[0] = {
          text: "Positions organization",
          disabled: false,
          href: "/organization/positions",
        };
        items[1] = {
          text: "Roles attached",
          disabled: false,
          href: `/organization/positions/position/${this.$route.params.pId}`,
        };
        items[2] = {
          text: "Responsibility",
          disabled: true,
        };
      }
      return items;
    },
  },
  async mounted() {
    this.accountId = JSON.parse(localStorage.getItem("currentAccountID"));
    this.currentRoleId = this.$route.params.objId;
    if (this.currentRoleId) {
      this.$loader.show();
      await this.getRoleAttachmentData(this.currentRoleId);
      if (this.selectedTab === 3) {
        await this.getChatterData(this.currentRole);
      }
      if (this.$route.name === "OrgPositionDetailObjId") {
        await this.getPositionByID();
      }
      this.$loader.hide();
    }
    document.addEventListener("mousedown", this.handleClickOutside);

    // Subscribe to IQ overlay events using the store
    const iqOverlayStore = useIQOverlayStore();
    this.unsubscribeCreateAndAttach = iqOverlayStore.onCreateAndAttach(
      this.handleCreateAndAttachSuggestion
    );
    this.unsubscribeReject = iqOverlayStore.onReject(
      this.handleRejectSuggestion
    );
    this.unsubscribeSuggestMore = iqOverlayStore.onSuggestMore(
      this.handleSuggestMore
    );
    this.unsubscribeEdit = iqOverlayStore.onEdit(this.handleEditSuggestion);
  },
  beforeDestroy() {
    document.removeEventListener("mousedown", this.handleClickOutside);

    // Unsubscribe from IQ overlay events
    if (this.unsubscribeCreateAndAttach) this.unsubscribeCreateAndAttach();
    if (this.unsubscribeReject) this.unsubscribeReject();
    if (this.unsubscribeSuggestMore) this.unsubscribeSuggestMore();
    if (this.unsubscribeEdit) this.unsubscribeEdit();
  },
  watch: {
    attachedResponsibilitiesIds(newVal) {
      if (newVal) {
        const index = this.menuItems.findIndex(
          (el) => el.title == "Attachments"
        );
        if (index > -1) {
          this.menuItems[index].count = newVal.length;
        }
      }
    },
    filteredResponsibilities(newVal) {
      if (newVal) {
        const index = this.menuItems.findIndex(
          (el) => el.title == "Attachments"
        );
        this.menuItems[index].count = newVal.length;
        this.renderIndex++;
      }
    },
    totalChatterData(newVal) {
      if (newVal) {
        const index = this.menuItems.findIndex((el) => el.title == "Chatter");
        this.menuItems[index].count = newVal;
        this.renderIndex++;
      }
    },
  },
  methods: {
    async handleOpenChatterDrawer(typeData) {
      // Store the current item for load more functionality
      this.currentChatterItem = typeData;
      // Call the mixin method with isLoadMore = false (initial load)
      await this.openChatterDrawer(typeData, false);
    },
    async handleLoadMoreChatterData() {
      // Use the stored current item to load more data
      if (this.currentChatterItem) {
        await this.openChatterDrawer(this.currentChatterItem, true);
      }
    },
    resetAIData() {
      this.aiData = {
        visible: [],
        stored: [],
        remaining: 0,
      };
      this.aiDialog = false;
      this.aiDialogKey++;
    },
    handleAppliedFilters(filters) {
      this.appliedFilters = filters;
    },
    async attachResponsibilityToRole() {
      this.isAssigningObject = true;
      this.$loader.setAppLoading(true);
      try {
        await this.attachedResponsibilityToRole();
        this.$notifications.success("Role attached successfully.");
        this.showAttachRoleDialog = false;
        await this.getRoleById(this.currentRole.id);
        await this.reloadOrgRoleData();
      } catch (e) {
        console.log("e: ", e);
      }
      this.isAssigningObject = false;
      this.$loader.setAppLoading(false);
    },
    async addNewRole(item) {
      try {
        this.$loader.show();
        const payload = {
          name: item.name,
          account: this.accountId,
        };
        const newRole = await this.$store.dispatch(
          "readinessCatalogsStore/createRole",
          { role: payload, accountId: this.accountId }
        );
        this.attachmentId = newRole.id;
        await this.attachedResponsibilityToRole();
        this.showAttachRoleDialog = false;
        await this.getRoleById(this.currentRole.id);
        await this.reloadOrgRoleData();
      } catch (e) {
        console.error(e);
      } finally {
        this.$loader.hide();
      }
    },
    showThreeMoreAIData() {
      const storedDataLength = this.aiData.stored.length;
      const visibleDataLength = this.aiData.visible.length;
      const remainingLengthStored = storedDataLength - visibleDataLength;
      this.aiData.remaining = remainingLengthStored;
      let subArray = [];
      if (remainingLengthStored > 3) {
        subArray = this.aiData.stored.slice(
          visibleDataLength,
          visibleDataLength + 3
        );
      } else {
        subArray = this.aiData.stored.slice(
          visibleDataLength,
          visibleDataLength + remainingLengthStored
        );
      }
      this.aiData.visible = [...this.aiData.visible, ...subArray];
    },
    async openChatter(data) {
      this.listData = data;
      this.drawer = true;
      // Only load chatter data if it hasn't been loaded yet
      if (this.roleChatterData.length === 0) {
        await this.getChatterData(data);
      }
    },
    closeDrawer(data) {
      if (data) {
        this.drawer = false;
      }
    },
    handleClickOutside(event) {
      const drawerContainer = this.$refs.drawerContainer;
      if (
        drawerContainer &&
        !drawerContainer.$el.contains(event.target) &&
        !this.$el.contains(event.target)
      ) {
        this.closeDrawer(this.listData);
      }
    },
    async reOrderData(reOrderData) {
      console.log("reOrderData: ", this.currentRoleId);
      this.accountId = JSON.parse(localStorage.getItem("currentAccountID"));
      try {
        await reOrderSequenceData(
          this.accountId,
          this.currentRoleId,
          reOrderData.reordered_ids
        );
      } catch (e) {
        console.log("e: ", e);
      }
    },
    async getPositionByID() {
      this.accountId = JSON.parse(localStorage.getItem("currentAccountID"));
      if (!this.$route.params.pId) this.$router.go(0);
      const { data } = await getPositionId(
        this.accountId,
        this.$route.params.pId
      );
      if (data) {
        this.positionHeaderState = {
          status: data.status,
          icon: "org_icon_position",
          label: "Position",
          name: `${this.getOrgCodeName(data)} ${data.name}`,
        };
      }
    },
    async onSaveAIData(aiData) {
      try {
        this.aiDialog = false;
        this.aiDialogKey++;
        this.aiLoadingState.text =
          "Creating and Attaching Selected Responsibilities…";
        this.aiLoadingState.show = true;
        const bulkResponsibilities = aiData.map((el) => ({
          name: el.name,
          account: this.accountId,
        }));
        const { data } = await createBulkResponsiblities(
          this.accountId,
          bulkResponsibilities
        );
        const responsibilitiesToAttachArray = data.map((el) => {
          return { responsibility: el.id };
        });
        const bulkResponsibilitiesAttachData = {
          role: this.currentRole.id,
          responsibilities: responsibilitiesToAttachArray,
        };
        await attachResponsibilitiesToRoleBulk(
          this.accountId,
          this.currentRole.id,
          bulkResponsibilitiesAttachData
        );
        await this.reloadOrgRoleData();
        await this.getRoleById(this.currentRole.id);
        await this.resetAIData();
      } catch (e) {
        console.error("error: ", e);
      } finally {
        this.aiLoadingState.show = false;
      }
    },
    async getAIData(withExclude) {
      try {
        if (this.aiGenerating) {
          this.aiLoadingState.show = true;
          return;
        }
        this.loadingAIProcess = true;
        this.aiGenerating = true;
        this.aiSuccessDataReady = false;
        this.aiLoadingState.text =
          "Analyzing and creating  Responsibilities...";
        this.aiLoadingState.show = true;
        const roleName = this.currentRole?.name;
        const prompt = `Create a list of responsibilities for the role ${roleName}, return only an array in JSON format example:
                 [ { name: "responsibility 1" } ]. Do not wrap the json codes in JSON markers`;
        const promptWithExclude = `Create a list of responsibilities for the role ${roleName}, exclude the following responsibilities
            [${this.filteredResponsibilities.map(
              (el) => el.data.name
            )}], return only an array in JSON format example:
             [ { name: "responsibility 1"} ]
                Do not wrap the json codes in JSON markers`;
        const request = askOpenai({
          model: "gpt-4o-mini",
          instructions: withExclude ? promptWithExclude : prompt,
          input: "string",
        });
        this.aiRequestPromise = request;
        const response = await request;
        const openaiResponse = JSON.parse(response.data.response);
        this.aiData.stored = openaiResponse;
        this.showThreeMoreAIData();
        this.aiSuccessDataReady = true;
      } catch (e) {
        console.error("e: ", e);
      } finally {
        this.loadingAIProcess = false;
        this.aiGenerating = false;
        this.aiRequestPromise = null;
        this.aiLoadingState.show = false;
        if (this.aiSuccessDataReady) {
          this.aiDialog = true;
        }
      }
    },
    handleAIAction(withExclude = false) {
      if (this.aiGenerating) {
        this.aiLoadingState.show = true;
        return;
      }
      this.getAIData(withExclude);
    },
    async handleActivateResponsibility() {
      await this.activateResponsibility();
      this.showActivateResponsiblityDialog = false;
      await this.reloadOrgRoleData();
      await this.getRoleById(this.currentRole.id);
    },
    async handleRetireResponsibility() {
      await this.retireResponsibility();
      this.showRetireResponsibilityDialog = false;
      await this.reloadOrgRoleData();
      await this.getRoleById(this.currentRole.id);
    },
    async handleReActivateResponsibility() {
      await this.reActivateResponsibility();
      this.showReActivateResponsiblityDialog = false;
      await this.reloadOrgRoleData();
      await this.getRoleById(this.currentRole.id);
    },
    async getRoleAttachmentData(roleId) {
      let storeFilterKey = "readinessCatalogsRoleAttachmentresponsibility";
      await this.$store.dispatch("filterStore/loadFilters", storeFilterKey);
      const savedFilters = this.$store.state.filterStore.filters;
      const { data } = await getRole(this.accountId, roleId);
      this.currentRole = data;
      await this.loadResponsibilitiesAttachedToRole({
        limit: 10,
        offset: 0,
        search: "",
        filters: savedFilters || [],
        page: 1,
        roleId: this.currentRole.id,
      });
    },
    async detachOrgObject(data) {
      await this.detachItems(data, async () => {
        // Refresh role data to get updated attached count
        await this.getRoleById(this.currentRole.id);
        await this.reloadOrgRoleData();
        if (data.callBackFunc && typeof data.callBackFunc === "function") {
          data.callBackFunc();
        }
      });
    },
    getOrgCodeName(currentRole) {
      if (currentRole?.code_str) {
        return currentRole.code_str.split(" ")[0];
      } else {
        return "#" + currentRole?.code;
      }
    },
    async handlePagination(paginationData) {
      try {
        this.$loader.show();
        // Calculate offset based on page number
        const limit = 10;
        const offset = (paginationData.page - 1) * limit;

        // Call the store function with search parameters
        await this.loadResponsibilitiesAttachedToRole({
          limit: limit,
          offset: offset,
          search: "",
          filters: [],
          page: paginationData.page,
          roleId: this.currentRole.id,
        });
      } catch (error) {
        console.error("Search error:", error);
      } finally {
        setTimeout(() => {
          this.$loader.hide();
        }, 500);
      }
    },
    async appliedFilterFromAPI(data) {
      this.appliedFiltersFromAPI = data;
      try {
        this.$loader.show();
        await this.loadResponsibilitiesAttachedToRole({
          limit: 10,
          offset: 0,
          search: "",
          filters: data,
          page: 1,
          roleId: this.currentRole.id,
        });
      } catch (error) {
        console.error("Search error:", error);
      } finally {
        setTimeout(() => {
          this.$loader.hide();
        }, 500);
      }
    },
    async searchTextData(data) {
      this.currentSearchTerm = data.name;
      try {
        this.$loader.show();
        await this.loadResponsibilitiesAttachedToRole({
          limit: 10,
          offset: 0,
          search: this.currentSearchTerm,
          filters: this.appliedFiltersFromAPI || [],
          page: 1,
          roleId: this.currentRole.id,
        });
      } catch (error) {
        console.error("Search error:", error);
      } finally {
        setTimeout(() => {
          this.$loader.hide();
        }, 500);
      }
    },
    openAttachRes() {
      this.attachedResDialog = true;
      this.getListOfResponsibilities(this.currentRole.id);
      this.openDefault = true;
    },
    handleItemSelected(data) {
      if (!data || !data.id) return;
      this.attachmentId = data.id;
    },
    async addResponsibility(name) {
      try {
        const payload = {
          name: name,
          account: this.accountId,
        };
        const newRes = await createResponsibility(this.accountId, payload);
        return newRes;
      } catch (e) {
        console.log("e: ", e);
      }
    },
    async addHandleItemSelected(item) {
      const { data } = await this.addResponsibility(item.name);
      this.attachmentId = data.id;
      await this.attachedRes();
      this.attachedResDialog = false;
    },
    async attachedRes() {
      this.isAssigningObject = true;
      try {
        this.$loader.show();
        const objId = this.currentRole.id;
        const payload = {
          attachment_id: this.attachmentId,
        };
        await attachResponsibilityToRole(this.accountId, objId, payload);
        await this.reloadOrgRoleData();
        this.$loader.hide();
        this.attachedResDialog = false;
        await this.getRoleById(this.currentRole.id);
      } catch (e) {
        this.$loader.hide();
        console.log("e: ", e);
      } finally {
        this.isAssigningObject = false;
      }
    },
    async refreshData() {
      const roleId = this.$route.params.objId;
      if (roleId) {
        const { data } = await getRole(this.accountId, roleId);
        this.currentRole = data;
        const attachments = data.attachments.filter((el) => {
          return el.type == "responsibility";
        });
        await this.$store.dispatch(
          "readinessCatalogsStore/loadResponsibilities"
        );
        this.attachedResponsibilitiesIds = attachments.map((el) => el.id);
        // Refresh chatter data whenever role data is refreshed
        await this.refreshChatterData();
      }
    },
    async handleTabChange(tab) {
      this.selectedTab = tab;
      // Load chatter data when switching to the Chatter tab (index 3)
      if (tab === 3 && this.currentRole && this.roleChatterData.length === 0) {
        await this.getChatterData(this.currentRole);
      }
    },
    async refreshChatterData() {
      if (this.currentRole) {
        try {
          this.$loader.show();
          // Clear existing chatter data and pagination cache
          this.roleChatterData = [];
          this.totalRoleChatterData = 0;
          if (this.loadedPages[this.currentRole.id]) {
            delete this.loadedPages[this.currentRole.id];
          }
          // Reload chatter data
          await this.getChatterData(this.currentRole);
        } catch (e) {
          console.error("Error refreshing chatter data:", e);
        } finally {
          this.$loader.hide();
        }
      }
    },
    async getChatterData(role) {
      const roleId = role.id;
      const currentLength = this.roleChatterData.length;
      const page = Math.floor(currentLength / 10) + 1;
      if (!this.loadedPages[roleId]) {
        this.loadedPages[roleId] = new Set();
      }
      if (this.loadedPages[roleId].has(page)) {
        console.log(`Page ${page} for role ${roleId} already loaded.`);
        return;
      }
      const { data } = await getChatterList(
        this.accountId,
        roleId,
        "role",
        page
      );
      this.loadedPages[roleId].add(page);
      if (data && data.count) {
        this.totalRoleChatterData = data.count;
      }
      if (data && data.results) {
        const chatterItems = transformChatterData(data.results);
        this.roleChatterData.push(...chatterItems);
      }
    },
    handleReadinessOperations(operation) {
      if (
        operation.data &&
        operation.data.data &&
        operation.data.data.type === "responsibility"
      ) {
        this.currentResponsibility = JSON.parse(JSON.stringify(operation.data));
        this.currentObj = operation.data.data.type;
      } else {
        this.currentObj = "role";
        this.roleHasDraftResponsibility = operation.data.attachments.filter(
          (item) => item.status === "draft"
        ).length;
      }
      switch (operation.item.value) {
        case "activate_role":
          this.activateRoleDialog = true;
          break;
        case "attach_responsibility_role":
          this.attachedResDialog = true;
          this.currentRoleId = this.currentRole.id;
          this.getListOfResponsibilities(this.currentRole.id);
          this.openDefault = true;
          break;
        case "retired_role":
          this.retiredRoleDialog = true;
          break;
        case "delete_role":
          this.deleteRoleDialog = true;
          break;
        case "rename_role":
          this.showRenameRoleDialog = true;
          break;
        case "de_activate_role":
          this.deActivateRoleDialog = true;
          break;
        case "re_activate_role":
          this.reActivateRoleDialog = true;
          break;
        case "rename_responsibility":
          this.showRenameResponsibilityDialog = true;
          break;
        case "delete_responsibility":
          this.deleteResponsibilityDialog = true;
          break;
        case "activate_responsibility":
          this.showActivateResponsiblityDialog = true;
          break;
        case "retire_responsibility":
          this.showRetireResponsibilityDialog = true;
          break;
        case "de_activate_responsibility":
          this.showDeActivateResponsiblityDialog = true;
          break;
        case "attach_role":
          this.currentResponsibilityId = this.currentResponsibility.realId;
          this.getListOfRoles(this.currentResponsibility.realId);
          this.showAttachRoleDialog = true;
          break;
        case "re_activate_responsibility":
          this.showReActivateResponsiblityDialog = true;
          break;
        case "archive_action":
          this.archiveAction = "archive";
          this.showArchihvedResponsiblityDialog = true;
          break;
        case "unarchive_action":
          this.archiveAction = "unarchive";
          this.showArchihvedResponsiblityDialog = true;
          break;
        default:
          break;
      }
    },
    closeDialog() {
      this.activateRoleDialog = false;
      this.retiredRoleDialog = false;
      this.deleteRoleDialog = false;
      this.showRenameRoleDialog = false;
      this.deActivateRoleDialog = false;
      this.reActivateRoleDialog = false;
      this.showRenameResponsibilityDialog = false;
      this.showActivateResponsiblityDialog = false;
      this.showRetireResponsibilityDialog = false;
      this.showDeActivateResponsiblityDialog = false;
      this.showAttachRoleDialog = false;
      this.showReActivateResponsiblityDialog = false;
      this.showArchihvedResponsiblityDialog = false;
      this.archiveAction = null;
      this.openDefault = false;
    },
    async activateOrgRole() {
      if (this.roleHasDraftResponsibility) {
        this.$loader.setAppLoading(false);
        this.activateRoleDialog = false;
        this.showActivateResponsibility = true;
        return;
      }
      try {
        this.$loader.setAppLoading(true);
        const idRole = this.currentRole?.id;
        const nameRole = this.currentRole?.name;
        const payload = {
          name: nameRole,
          status: "active",
          account: this.accountId,
        };
        await updateRole(this.accountId, idRole, payload);
        this.activateRoleDialog = false;
        await this.reloadOrgRoleData();
        this.$loader.setAppLoading(false);
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.log("e: ", e);
      }
    },
    async skipActivateResponsibilities() {
      await this.processRoleActivation(false);
      await this.getRoleAttachmentData(this.currentRoleId);
      await this.reloadOrgRoleData();
    },
    async activateAttachResponsibilities() {
      await this.processRoleActivation(true);
      await this.getRoleAttachmentData(this.currentRoleId);
      await this.reloadOrgRoleData();
    },
    async renameOrgRole(newName) {
      try {
        this.$loader.setAppLoading(true);
        const idRole = this.currentRole?.id;
        if (!idRole) {
          throw "no id";
        }
        const payload = {
          name: newName,
        };
        await updateNameRole(this.accountId, idRole, payload);
        this.showRenameRoleDialog = false;
        await this.getRoleById(idRole);
        await this.reloadOrgRoleData();
        this.$loader.setAppLoading(false);
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.log("e: ", e);
      }
    },
    async getRoleById(idRole) {
      const { data } = await getRole(this.accountId, idRole);
      this.currentRole = data;
    },
    async deleteOrgRole(val) {
      try {
        this.$loader.setAppLoading(true);
        const idRole = this.currentRole?.id;
        const payload = {
          delete_draft_responsibilities: val,
        };
        if (val) {
          await deleteReadinessRoleWithResponsibilities(
            this.accountId,
            idRole,
            payload
          );
        } else {
          await deleteReadinessRole(this.accountId, idRole);
        }
        this.deleteRoleDialog = false;
        this.$loader.setAppLoading(false);

        this.$router.push("/readiness/catalogs/roles");
      } catch (e) {
        this.$loader.setAppLoading(false);
      }
    },
    async retiredOrgRole() {
      try {
        const idRole = this.currentRole?.id;
        const nameRole = this.currentRole?.name;
        this.$loader.setAppLoading(true);
        const payload = {
          name: nameRole,
          status: "retired",
          account: this.accountId,
        };
        await updateRetiredRole(this.accountId, idRole, payload);
        this.retiredRoleDialog = false;
        await this.getRoleById(idRole);
        await this.reloadOrgRoleData();
        this.$loader.setAppLoading(false);
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.log("e: ", e);
      }
    },
    async deActivateOrgRole() {
      try {
        this.$loader.setAppLoading(true);
        const idRole = this.currentRole?.id;
        const nameRole = this.currentRole?.name;
        const payload = {
          name: nameRole,
          status: "inactive",
          account: this.accountId,
        };
        await updateDeActiveRole(this.accountId, idRole, payload);
        this.deActivateRoleDialog = false;
        await this.getRoleById(idRole);
        await this.reloadOrgRoleData();
        this.$loader.setAppLoading(false);
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.log("e: ", e);
      }
    },
    async reActivateOrgRole() {
      try {
        this.$loader.setAppLoading(true);
        const idRole = this.currentRole?.id;
        const nameRole = this.currentRole?.name;
        const payload = {
          name: nameRole,
          status: "inactive",
          account: this.accountId,
        };
        await updateReActiveRole(this.accountId, idRole, payload);
        this.reActivateRoleDialog = false;
        await this.getRoleById(idRole);
        await this.reloadOrgRoleData();
        this.$loader.setAppLoading(false);
      } catch (e) {
        this.$loader.setAppLoading(false);
        console.log("e: ", e);
      }
    },
    async onArchiveCatalogs() {
      if (this.currentObj === "role") {
        if (this.archiveAction === "archive") {
          await this.archiveRole("attachRoles");
          this.$router.push("/readiness/catalogs/roles");
        } else if (this.archiveAction === "unarchive") {
          await this.unarchiveRole("attachRoles");
          await this.getRoleById(this.currentRole.id);
          await this.reloadOrgRoleData();
        }
      } else {
        if (this.archiveAction === "archive") {
          await this.archiveResponsibility("attachRes");
        } else if (this.archiveAction === "unarchive") {
          await this.unarchiveResponsibility("attachRes");
        }
      }
    },
    async deleteAttachResponsibility() {
      try {
        this.$loader.setAppLoading(true);
        const respId = this.currentResponsibility.realId;
        const roleId = this.currentRole.id;
        await deleteResponsibility(this.accountId, respId);
        this.deleteResponsibilityDialog = false;
        this.currentResponsibility = null;
        await this.getRoleById(roleId);
        await this.reloadOrgRoleData();
      } catch (e) {
        console.error("e: ", e);
      } finally {
        this.$loader.setAppLoading(false);
      }
    },
    handleAddIQAction() {
      // Get role code and name
      const roleCode = this.getOrgCodeName(this.currentRole);
      const roleName = this.currentRole?.name || "";

      // Format the prompt
      const prompt = `Pls suggest responsibilities for Role ${roleCode} - ${roleName}`;

      // Use store to open IQ Overlay with the prompt and type
      const iqOverlayStore = useIQOverlayStore();
      iqOverlayStore.openOverlay({
        prompt,
        type: "roleResponsibility",
        roleName: `${roleCode} - ${roleName}`,
        suggestedResponsibilities: [],
      });
    },
    async handleCreateAndAttachSuggestion(data) {
      const iqOverlayStore = useIQOverlayStore();
      const iqChatStore = useIQChatStore();

      try {
        // Set loading state
        iqOverlayStore.setCreatingResponsibility(true);
        // Clear any previous error
        iqOverlayStore.setCreationError("");

        // Create the responsibility
        const payload = {
          name: data.responsibility.name,
          account: this.accountId,
        };
        const newRes = await createResponsibility(this.accountId, payload);

        // Attach to current role
        const attachPayload = {
          attachment_id: newRes.data.id,
        };
        await attachResponsibilityToRole(
          this.accountId,
          this.currentRole.id,
          attachPayload
        );

        // Show success message in IQ overlay chat with code_str
        const codeStr = newRes.data.code_str || `#${newRes.data.id}`;
        const successMessage = `Just created and attached Responsibility ${codeStr}`;
        iqChatStore.addAIMessage(successMessage);

        // Remove the suggestion from the store (navigator will move to next automatically)
        iqOverlayStore.removeSuggestion(data.index - 1);

        // Reload data
        await this.reloadOrgRoleData();
        await this.getRoleById(this.currentRole.id);
      } catch (e) {
        console.error("Error creating and attaching responsibility:", e);

        // Extract error message
        let errorMessage = "";

        // Check if it's a duplicate name error - check multiple possible locations
        if (e.response?.data) {
          if (Array.isArray(e.response.data) && e.response.data.length > 0) {
            const nameError = e.response.data[0];
            if (
              typeof nameError === "string" &&
              nameError.toLowerCase().includes("already exists")
            ) {
              errorMessage =
                "Name already exists. Only unique names are allowed";
            } else if (
              typeof nameError === "string" &&
              nameError.toLowerCase().includes("unique")
            ) {
              errorMessage =
                "Name already exists. Only unique names are allowed";
            } else {
              errorMessage = nameError;
            }
          } else if (typeof e.response.data.name === "string") {
            const nameError = e.response.data.name;
            if (
              nameError.toLowerCase().includes("already exists") ||
              nameError.toLowerCase().includes("unique")
            ) {
              errorMessage =
                "Name already exists. Only unique names are allowed";
            } else {
              errorMessage = nameError;
            }
          }
        } else if (e.response?.data?.message) {
          errorMessage = e.response.data.message;
        } else if (e.message && !e.message.includes("status code")) {
          errorMessage = e.message;
        }

        // Set error in store so it shows in the navigator
        iqOverlayStore.setCreationError(errorMessage);

        // DON'T show error message in IQ overlay chat - only in the form
        // iqChatStore.addAIMessage(errorMessage);

        // DON'T show toast notification - error is already shown in the form
        // this.$toast.error(errorMessage);
      } finally {
        // Always hide loading state in finally block to ensure cleanup
        // This ensures consistent state regardless of success or error path
        iqOverlayStore.setCreatingResponsibility(false);
      }
    },
    handleRejectSuggestion(data) {
      console.log("Reject suggestion:", data);
      // The suggestion removal is handled by the navigator component
      // No additional action needed here
    },
    handleSuggestMore() {
      console.log("Suggest more clicked");
      // The IQOverlay handles resubmitting the query internally
      // No additional action needed here
    },
    handleEditSuggestion(data) {
      console.log("Edit suggestion:", data);
      // TODO: Implement edit functionality if needed
      // You could open a dialog to edit the responsibility name/purpose
    },
  },
};
</script>
<style scoped>
.ex-rolepage .proficiency {
  width: 145px;
}
.sliderWidthIcon {
  width: 100%;
}
</style>
<style>
.ex-rolepage .storybook-badge--active {
  width: 56px;
}
.ex-rolepage .stream-wrapper {
  box-shadow: none;
}
.role-to-res .storybook-button--btn-normal-hover-icon {
  font-size: 14px;
  line-height: 2;
}
.role-to-res img {
  position: relative;
}
.custom-org-icon svg {
  width: 70px;
  height: 70px;
}
.custom-org .org-object-card {
  flex-direction: row-reverse;
  gap: 10px;
}
.custom-org .org-object-card:hover {
  background: none;
}
.custom-status {
  position: relative;
  top: 7px;
}
.org-menu-role {
  position: relative;
  right: 25px;
  top: 23px;
}
.chatter-with-menu-role {
  display: flex;
  align-items: flex-start;
}
.chatter-type-icon {
  display: grid;
  justify-content: end;
}
.chatter-type-icon {
  padding: 6px;
  text-align: center;
  margin: 5px;
  margin-top: -4px;
  width: fit-content;
  cursor: url("../assets/cursorArrow.svg"), auto;
}
.chatter-type-icon:hover {
  background-color: #f2edff;
  padding: 6px;
  text-align: center;
  margin: 5px;
  margin-top: -4px;
  box-shadow: 0px 4px 4px 0px #0000000f;
  border-radius: 8px;
}
</style>
